/**
 * Reusable Toggle Component
 * Extracted from the hand-rolled switch pattern used across the Departments/
 * Sections forms (e.g. "Print KOT for this department") — same markup,
 * parameterized so it can be reused wherever a boolean switch is needed.
 */

import React, { useId } from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  id?: string;
  /** Tailwind class for the track's checked state, e.g. "peer-checked:bg-red-400" */
  activeColorClass?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  id,
  activeColorClass = 'peer-checked:bg-pos-primary',
}) => {
  const generatedId = useId();
  const toggleId = id || generatedId;

  return (
    <label
      htmlFor={toggleId}
      className={`flex items-center gap-3 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
    >
      <div className="relative">
        <input
          id={toggleId}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="peer sr-only"
        />
        <div
          className={`h-5 w-10 rounded-full bg-gray-200 transition-colors ${activeColorClass}`}
        />
        <div className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform peer-checked:translate-x-5" />
      </div>
      {label && <span className="text-sm text-gray-700">{label}</span>}
    </label>
  );
};
